export const SCROLL_TIMEOUT = 150 // Time in ms to wait before showing header after scroll stops

export function handleScroll(callback: (isVisible: boolean) => void) {
  let lastScrollTop = 0
  let isScrollingDown = false
  let scrollTimeout: NodeJS.Timeout | null = null

  return () => {
    const st = window.scrollY

    // Clear the timeout on each scroll
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }

    // Determine scroll direction
    const currentlyScrollingDown = st > lastScrollTop

    // If we changed direction from down to up, show immediately
    if (isScrollingDown && !currentlyScrollingDown) {
      callback(true)
    } else if (currentlyScrollingDown) {
      // Only hide when scrolling down
      callback(false)
    }

    // Update scroll direction for next check
    isScrollingDown = currentlyScrollingDown

    // Set timeout to show navbar when scrolling stops
    scrollTimeout = setTimeout(() => {
      callback(true)
    }, SCROLL_TIMEOUT)

    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }
}
